import { render } from "./LocationPage.vue?vue&type=template&id=b6c4681c"
import script from "./LocationPage.vue?vue&type=script&lang=js"
export * from "./LocationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__